import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

export const OrdersColumn = styled.div`
  width: 30%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
  max-height: ${({ overflow }) => (overflow === 'true' ? '650px' : '')};
  overflow-x: ${({ overflow }) => (overflow === 'true' ? 'hidden' : '')};
  overflow-y: ${({ overflow }) => (overflow === 'true' ? 'auto' : '')};
`;

export const ProOrderCard = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
  padding: 15px 10px;
  display: flex;
  align-items: center;
  cursor: ${({ active, taskHasSelectedQuote }) => (!active && !taskHasSelectedQuote ? 'pointer' : '')};
  opacity: ${({ active, taskHasSelectedQuote }) => (!active && taskHasSelectedQuote ? 0.5 : 1)};
  border-bottom: 1px solid ${colors.greyLighter};
  &.active {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    background: ${colors.blueLight2};
  }
  &.active:after {
    left: 100%;
    top: 20%;
    border: solid ${colors.greyLighter};
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(246, 249, 255, 0);
    border-left-color: ${colors.blueLight2};
    border-width: 15px;
    margin-top: -15px;
    filter: drop-shadow(2px 0px 1px rgba(0, 0, 0, 0.15));
  }
`;

export const Left = styled.div`
  margin-right: 20px;
  opacity: ${({ proValidated }) => (!proValidated ? 0.5 : 1)};
`;
export const ProPhoto = styled.img`
  width: 86px;
  height: 100px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  object-fit: cover;
`;

export const RatingCard = styled.div`
  width: 80%;
  height: 15px;
  background: ${colors.white};
  border-radius: 7px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  margin: -8px auto 0px auto;
  position: relative;
`;
export const RatingStars = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  img {
    margin: -13px 0.5px 0;
  }
`;
export const Right = styled.div`
  width: 60%;
  opacity: ${({ proValidated }) => (!proValidated ? 0.5 : 1)};
`;
export const ProName = styled.p`
  font: 500 13px ${fonts.secondary};
  color: ${colors.greyDark};
  margin-bottom: 4px;
`;
export const ResumeChat = styled.p`
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
  color: ${({ isTyping }) => (isTyping ? colors.green : colors.grey2)};
`;
export const OrderDate = styled.p`
  font-size: 11px;
  margin-bottom: 8px;
  padding-bottom: 7px;
  color: ${colors.grey2};
  border-bottom: 1px solid ${colors.greyLighter};
`;

export const OrderPrice = styled.p`
  background: ${colors.white};
  border-radius: 20px;
  box-shadow: 0px 1px 4px ${colors.greyLight};
  font: 14px ${fonts.secondary};
  text-align: center;
  padding: 9px 30px 7px;
  margin-top: 8px;
`;

export const InvalidatedText = styled.p`
  font-size: 14px;
  padding-top: 5px;
  text-align: center;
`;

export const UnreadMessages = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 14px;
  background: ${colors.green};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
`;
